import { render, staticRenderFns } from "./MessageStorageFile.vue?vue&type=template&id=3f525a30&scoped=true"
import script from "./MessageStorageFile.vue?vue&type=script&lang=js"
export * from "./MessageStorageFile.vue?vue&type=script&lang=js"
import style0 from "./MessageStorageFile.vue?vue&type=style&index=0&id=3f525a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f525a30",
  null
  
)

export default component.exports